import React from "react";
import { dateToToday } from "../../../utils/helper.jsx";

const SentMessageContent = ({ message }) => {
  const getNick = (name) => {
    if (!name) return "";
    const splitName = name.toUpperCase().split(" ");
    let nick = "";
    splitName.forEach((s) => {
      nick += s.charAt(0);
    });

    return nick;
  };
  return (
    <>
      <div className="widget-chat-item">
        <div className="widget-chat-media">
          <div className="username-wrapper" mr={1}>
            {getNick(`${message.user?.firstname} ${message.user?.lastname}`)}
          </div>
        </div>
        <div className="widget-chat-content">
          <div className="widget-chat-name">
            {message.user?.firstname} - {dateToToday(message?.created_at)}
          </div>
          <div className="widget-chat-message last">{message?.content}</div>
        </div>
      </div>
    </>
  );
};

export default SentMessageContent;
